import { ga4SendGenericEvent } from '../utils/gtm-utilities.es6';

const handleVisibility = (entries, observer, styleId, action) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            ga4SendGenericEvent(action, { styleCode: styleId });
            observer.unobserve(entry.target);
        }
    });
};

const overlayUpdate = element => {
    const iconSVG = element.querySelector('svg').outerHTML;
    const label = element.querySelector('.sustainability-label');
    const message = element.querySelector('.sustainability-description');
    const relatedOverlaySelector = element.querySelector('.sustainability-overlay-opener').getAttribute('href');
    const relatedOverlay = document.querySelector(relatedOverlaySelector);

    relatedOverlay.querySelector('.sustainability-overlay-icon').innerHTML = iconSVG;
    relatedOverlay.querySelector('.sustainability-overlay-title').innerHTML = label.innerHTML;
    relatedOverlay.querySelector('.sustainability-overlay-main-content').innerHTML = message.innerHTML;

    const agecCommitmentLink = relatedOverlay.querySelector('#agec_commitment_link');
    if (agecCommitmentLink) {
        const styleId = element.getAttribute('data-style-id');
        agecCommitmentLink.addEventListener('click', () => ga4SendGenericEvent('productPage.clickOnAGECLink', { styleCode: styleId }));
        const agecLinkObserver = new IntersectionObserver((entries, observer) => handleVisibility(entries, observer, styleId, 'productPage.displayAGECLink'), {
            root: null,
            threshold: 0.1
        });
        agecLinkObserver.observe(agecCommitmentLink);
    }
};

const onClickHandler = event => {
    const sustainabilityIcon = event.currentTarget;
    overlayUpdate(sustainabilityIcon);

    ga4SendGenericEvent('productPage.clickSustainabilityIcon', { styleCode: sustainabilityIcon.getAttribute('data-style-id') });
};

export const load = () => {
    const sustainabilityGroupButton = document.querySelectorAll('.sustainability-button');
    let hasAgecCommitmentLink = false;
    let styleId = '';
    sustainabilityGroupButton.forEach(el => {
        const sustainabilityIconObserver = new IntersectionObserver((entries, observer) => handleVisibility(entries, observer, styleId, 'productPage.displaySustainabilityIcon'), {
            root: null,
            threshold: 0.1
        });
        sustainabilityIconObserver.observe(el);
        el.addEventListener('click', onClickHandler);
        hasAgecCommitmentLink = hasAgecCommitmentLink || !!el.querySelector('#agec_commitment_link');
        styleId = el.getAttribute('data-style-id');
    });
    ga4SendGenericEvent('productPage.hasAGECLink', {
        styleCode: styleId,
        hasAGECLink: hasAgecCommitmentLink
    });
};
